import { action, reaction, observable } from 'mobx';
import i18next from 'i18next';

import { AppManager, Variables } from 'core/index';

import { clientStore } from 'apps/client/app';
import { ProjectConnManager } from 'apps/project/connManager';

import {
  ProfileProjectsQuery,
  InitiativeProjectsQuery,
} from 'apps/project/gql';

export default class ProjectsAppManager extends AppManager {
  static registryName = 'ProjectsAppManager';

  @observable projectsConn = null;

  lastQueryParameter = null;

  constructor(parent, init = {}) {
    super(parent, init);
    this.variables = new Variables({
      username: () =>
        clientStore.activeSpace
          ? clientStore.activeSpace?.path
          : clientStore.signedInProfile?.user?.username,
      slug: () => clientStore.activeSpace?.path,
      projectsCursor: () => null,
      projectsSortBy: () => this.projectsConn.sortBy,
      projectsCount: () => this.projectsConn.variables.batchSize,
      projectsFilterBy: () => this.projectsConn.variables.filterBy,
    });
    // this.ProjectsQuery();

    this.disposers.push(
      reaction(
        () => clientStore.activeSpace,
        activeSpace => {
          if (!activeSpace || activeSpace.spaceType === 'PROFILE') {
            // Next "if" is just an optimization so that the first query happens immediately (see { fireImmediately: true })
            // which will use the username from signedInProfile, but if the activeSpace that is resolved is the space
            // for that profile we don't want to requery.
            // There's a boolean so that this skip only happens once, which is reasonable but has no real usecase at time of writing.
            // We could potentially be getting into an activeSpace different than the one in signedInProfile,
            // hence the this.lastQueryParameter check.
            if (
              activeSpace &&
              clientStore.isTheCurrentActiveSpaceTheFirstOneUsed &&
              this.lastQueryParameter === this.variables.username
            ) {
              return;
            }

            this.setupConnManagerWithQuery(ProfileProjectsQuery);

            this.lastQueryParameter = this.variables.username;
            this.ProjectsQuery();
          } else if (activeSpace.spaceType === 'INITIATIVE') {
            this.setupConnManagerWithQuery(InitiativeProjectsQuery);

            this.lastQueryParameter = this.variables.slug;
            this.ProjectsQuery();
          }
        },
        { fireImmediately: true },
      ),
    );
  }

  setupConnManagerWithQuery = Query => {
    this.projectsConn?.dispose();
    this.projectsConn = new ProjectConnManager(this, {
      sortBy: 'recent',
      sortOptions: [
        ['recent', i18next.t('Recent')],
        ['contributions', i18next.t('Contributions')],
        ['followers', i18next.t('Followers')],
        ['pageviews', i18next.t('Views')],
      ],
      filterBy: [],
      initialBatchSize: 12,
      loadMoreQuery: Query,
    });
  };

  @action ProjectsQuery = () => {
    this.projectsConn.loadMore();
  };
}
